import aiApiClient from '../../../../cms/src/apiClient/ai-api-client';
import { useApplyTransactionInRange } from '../../hooks';
import React, { useCallback, useState } from 'react';
import { useEditorState } from '@remirror/react';
import CommandButton from '../CommandButton';
import { message } from 'antd';

export const FixGrammerIcon = React.memo(() => {
  return (
    <>
      <svg
        role="graphics-symbol"
        viewBox="0 0 16 16"
        className="aiFixSpellingGrammar"
        style={{ width: '16px', height: '16px', display: 'block', fill: 'rgb(144, 101, 176)', flexShrink: '0' }}
      >
        <path d="M6.57812 14.1621C6.23633 14.1621 5.9834 14.0186 5.74414 13.7246L2.20312 9.29492C2.03223 9.08301 1.95703 8.88477 1.95703 8.67969C1.95703 8.20801 2.30566 7.86621 2.78418 7.86621C3.08496 7.86621 3.29004 7.97559 3.48828 8.24219L6.55078 12.1729L12.4912 2.73926C12.6963 2.41797 12.8945 2.30176 13.2295 2.30176C13.708 2.30176 14.0361 2.62988 14.0361 3.10156C14.0361 3.28613 13.9814 3.47754 13.8379 3.69629L7.41211 13.7178C7.21387 14.0117 6.94043 14.1621 6.57812 14.1621Z"></path>
      </svg>
    </>
  );
});

const prepareFixSpellingPayload = ({ selectedText, sourceId }) => ({
  action: { type: 'fix_spelling_grammar' },
  source_id: sourceId,
  source: { value: selectedText },
  target: { tone: 'formal' },
});

export const FixGrammerButton = React.memo(({ fileId }) => {
  const { updateContentInRange, deleteSelection } = useApplyTransactionInRange();
  const [loading, setLoading] = useState(false);
  const editorState = useEditorState();

  const onClickHandler = useCallback(() => {
    setLoading(true);
    const { from, to } = editorState.selection;
    if (from && to) {
      const selectedText = editorState.doc.slice(from, to).toString();
      aiApiClient
        .post('/ai/documents/actions', prepareFixSpellingPayload({ selectedText, sourceId: fileId }))
        .then((response) => {
          const { chat_response } = response || {};
          if (chat_response?.content) {
            deleteSelection();
            updateContentInRange({ from, content: chat_response?.content });
          }
        })
        .catch((error) => {
          console.log(error);
          message.error('Unable to improve writing due to server error.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [editorState, deleteSelection, updateContentInRange, fileId]);

  return (
    <CommandButton
      label={'Fix Grammer'}
      labelOptions={{ className: 'command__button-text weight-normal' }}
      icon={<FixGrammerIcon />}
      loading={loading}
      enabled={true}
      onClick={onClickHandler}
    />
  );
});

export default FixGrammerButton;
